import { Phone } from "lucide-react";
import SiteFooter from "./SiteFooter";

const CTAFooter = () => {
  return (
    <>
      {/* Charity banner */}
      <section className="py-6 px-4 bg-acg-light-blue text-center">
        <p className="text-sm text-muted-foreground">
          ACG Southern Highlands Proudly Supports Sydney Children's Hospitals Foundation
        </p>
      </section>

      {/* CTA */}
      <section className="py-16 px-4 bg-acg-charcoal text-primary-foreground">
        <div className="container mx-auto text-center">
          <h3 className="text-lg text-primary-foreground/70 mb-2">
            Genuine Quality, Efficiency & Transparency
          </h3>
          <h2 className="text-3xl font-bold mb-8">Contact ACG Now & Experience the Difference</h2>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href="#service"
              className="bg-acg-blue text-primary-foreground font-bold px-8 py-3 rounded hover:opacity-90 transition-opacity"
            >
              Schedule your <span className="font-black">SERVICE</span>
            </a>
            <a
              href="#quote"
              className="bg-primary text-primary-foreground font-bold px-8 py-3 rounded hover:opacity-90 transition-opacity"
            >
              Schedule your <span className="font-black">QUOTE</span>
            </a>
          </div>
        </div>
      </section>

      {/* Bottom bar */}
      <div className="py-4 px-4 bg-acg-dark text-primary-foreground">
        <div className="container mx-auto flex flex-wrap items-center justify-between gap-4">
          <a href="tel:0480841485" className="flex items-center gap-2 font-bold">
            <Phone className="w-5 h-5" />
            CALL 0480 841 485
          </a>
          <a href="#quote" className="bg-primary text-primary-foreground font-bold px-6 py-2 rounded text-sm">
            SCHEDULE QUOTE
          </a>
          <div className="flex items-center gap-6 text-xs">
            <div className="text-center">
              <p className="font-bold">490+ Reviews</p>
              <p className="text-primary-foreground/70">4.9 ★</p>
            </div>
            <div className="text-center">
              <p className="font-bold">450+ Reviews</p>
              <p className="text-primary-foreground/70">4.8 ★</p>
            </div>
            <div className="text-center">
              <p className="font-bold">43+ Reviews</p>
              <p className="text-primary-foreground/70">5.0 ★</p>
            </div>
          </div>
        </div>
      </div>

      {/* Site Footer */}
      <SiteFooter />
    </>
  );
};

export default CTAFooter;
